import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  width: fit-content;
  margin: auto;
  display: flex;
  gap: 13px;
  & svg {
    margin: 0 0 0 10px;
    vertical-align: middle;
  }
  & svg path {
    fill: #fff;
  }
  & svg.disabled path {
    fill: #878787;
  }
  @media (max-width: 350px) {
    width: 100%;
    flex-direction: column;
    button {
      flex: 1;
    }
  }
`;
